(() => {
  const parser = new DOMParser();
  let controller = null;

  const swapFragments = (root, doc) => {
    const keys = new Set();
    root.querySelectorAll('[data-swap]').forEach((el) => keys.add(el.getAttribute('data-swap')));
    keys.forEach((key) => {
      const current = root.querySelectorAll('[data-swap="' + key + '"]');
      const fresh = doc.querySelectorAll('[data-swap="' + key + '"]');
      current.forEach((el, index) => {
        if (fresh[index]) el.innerHTML = fresh[index].innerHTML;
      });
    });
  };

  const onOptionChange = async (input) => {
    const root = input.closest('[data-product-section]');
    if (!root) return;

    const ids = Array.from(root.querySelectorAll('[data-option-input]:checked')).map((el) => el.getAttribute('data-option-value-id'));
    const sectionId = root.getAttribute('data-section-id');
    const baseUrl = root.getAttribute('data-url');
    const focusId = input.getAttribute('data-option-value-id');

    if (controller) controller.abort();
    controller = new AbortController();

    try {
      const response = await fetch(baseUrl + '?option_values=' + ids.join(',') + '&section_id=' + encodeURIComponent(sectionId), {
        signal: controller.signal,
      });
      const text = await response.text();
      const doc = parser.parseFromString(text, 'text/html');

      swapFragments(root, doc);

      const freshId = doc.querySelector('input[name="id"]');
      const currentId = root.querySelector('form[data-product-form] input[name="id"]');
      if (freshId && currentId) {
        currentId.value = freshId.value;
        currentId.dispatchEvent(new Event('change', { bubbles: true }));
        const url = new URL(window.location.href);
        url.searchParams.set('variant', freshId.value);
        window.history.replaceState({}, '', url.toString());
      }

      const restored = root.querySelector('[data-option-value-id="' + focusId + '"]');
      if (restored && document.activeElement === document.body) restored.focus();
    } catch (error) {
      if (error.name !== 'AbortError' && window.Theme) window.Theme.toast(window.theme.strings.error);
    }
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-option-input]');
    if (input) onOptionChange(input);
  });

  const initBuyBar = (root) => {
    const bar = root.querySelector('[data-buy-bar]');
    const triggers = Array.from(root.querySelectorAll('.buy-box [data-buy-trigger]')).concat(
      Array.from(document.querySelectorAll('[data-cta-trigger]'))
    );
    if (!bar || triggers.length === 0 || !('IntersectionObserver' in window)) return;

    const setVisible = (visible) => {
      bar.classList.toggle('is-visible', visible);
      if (visible) {
        bar.removeAttribute('inert');
      } else {
        bar.setAttribute('inert', '');
      }
    };

    const inView = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            inView.add(entry.target);
          } else {
            inView.delete(entry.target);
          }
        });
        setVisible(inView.size === 0);
      },
      { threshold: 0 }
    );
    triggers.forEach((trigger) => observer.observe(trigger));
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-product-section]').forEach((root) => {
      if (root.hasAttribute('data-product-ready')) return;
      root.setAttribute('data-product-ready', '');
      initBuyBar(root);
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
